import React from 'react'
import { SvgIcon } from '@mui/material'


export const UserIcon = ({sx,...props}) => {
    return (
        <SvgIcon {...{ sx: sx?.color ? { ...sx, stroke: sx.color, color: '#fff' } : sx, ...props }}>
            <path d="M8.68221 14C9.63251 14.6318 10.7733 15 12 15C13.2267 15 14.3675 14.6318 15.3178 14M15.3213 14C15.9519 14 16.2672 14 16.5303 14.0472C17.7648 14.2689 18.7311 15.2352 18.9528 16.4697C19 16.7328 19 17.0481 19 17.6787V19.4C19 19.9601 19 20.2401 18.891 20.454C18.7951 20.6422 18.6422 20.7951 18.454 20.891C18.2401 21 17.9601 21 17.4 21H6.6C6.03995 21 5.75992 21 5.54601 20.891C5.35785 20.7951 5.20487 20.6422 5.10899 20.454C5 20.2401 5 19.9601 5 19.4V17.6841C5 17.0485 5 16.7306 5.04798 16.4656C5.27087 15.2344 6.23442 14.2709 7.46558 14.048C7.73064 14 8.04846 14 8.6841 14M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </SvgIcon>
    )
}
